import { APP_INITIALIZER, ApplicationConfig, importProvidersFrom, inject, provideBrowserGlobalErrorListeners, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withComponentInputBinding, withInMemoryScrolling, withViewTransitions } from '@angular/router';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideServiceWorker } from '@angular/service-worker';
import { MatIconModule } from '@angular/material/icon';

import { provideFirebaseApp, initializeApp as initFirebase } from '@angular/fire/app';
import { provideAuth, getAuth } from '@angular/fire/auth';
import { provideFirestore, getFirestore } from '@angular/fire/firestore';
import { provideMessaging, getMessaging } from '@angular/fire/messaging';
import { environment } from '../environments/environment';

import { routes } from './app.routes';
import { AuthService } from './core/services/auth.service';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { HttpErrorInterceptor } from './shared/interceptors/http-error.interceptor';
import { IdempotencyInterceptor } from './shared/interceptors/idempotency.interceptor';
import { LoggingInterceptor } from './shared/interceptors/logging.interceptor';
import { SessionManagementService } from './core/services/session-management.service';

function initAuth(authService: AuthService, sessionService: SessionManagementService) {
  return () => {
    return new Promise<void>((resolve) => {
      authService.verifyToken().subscribe(() => {
        // Session management service is already injected and initialized
        resolve();
      });
    });
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideHttpClient(
      withFetch(), 
      withInterceptors([LoggingInterceptor, HttpErrorInterceptor, IdempotencyInterceptor, authInterceptor])
    ),
    {
      provide: APP_INITIALIZER,
      useFactory: initAuth,
      deps: [AuthService, SessionManagementService],
      multi: true
    },
    SessionManagementService,
    provideRouter(
      routes,
      withInMemoryScrolling({ scrollPositionRestoration: 'enabled', anchorScrolling: 'enabled' }),
      withViewTransitions(),
      withComponentInputBinding()
    ),
    provideAnimationsAsync(),
    provideServiceWorker('ngsw-worker.js', {
      enabled: environment.production,
      registrationStrategy: 'registerWhenStable:30000',
    }),
    importProvidersFrom(MatIconModule),
    provideFirebaseApp(() => initFirebase(environment.firebase)),
    provideAuth(() => getAuth()),
    provideFirestore(() => getFirestore()),
    // provideMessaging(() => getMessaging())
  ]
};
